import * as React from 'react'

import { observer } from 'mobx-react'

import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import Spinner from '~/client/src/shared/components/Spinner/Spinner'

interface ISubmitButton {
  text: string
  width: number
  loading?: boolean
  clickHandler: (e) => void
  disabled?: boolean
  isHidden?: boolean
  className?: string
}

@observer
export default class SubmitButton extends React.Component<ISubmitButton> {
  public render() {
    const {
      disabled,
      loading,
      width,
      text,
      clickHandler,
      isHidden,
      className = 'setup-form-controls submit-button-container',
    } = this.props

    return (
      <div className={className}>
        <Button
          size="lg"
          className="tw:m-5"
          style={{ width, visibility: isHidden ? 'hidden' : 'visible' }}
          onClick={clickHandler}
          disabled={disabled || loading}
        >
          {loading ? <Spinner size="xs" /> : text}
        </Button>
      </div>
    )
  }
}
